import React, {memo} from "react";
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {FaTimes} from "react-icons/fa";
import {useDispatch} from "react-redux";
import OrgForm from "../Forms/OrgForm";
import Loader from "../Loader";
import {createOrganization} from "../../redux/Actions/organizations.actions";
import {useFetchOrganizations} from "../../views/Organization/organizationTable/useOrganizationTableData";

const AddAlert = (props) => {
  const dispatch = useDispatch();
  const {refetch} = useFetchOrganizations();
  const {open, onClose} = props;

  const onSubmit = (formDetails) => {
    let payload = {};
    Object.values(formDetails).map((each) => {
      payload = {
        ...payload,
        ...each,
      };
    });
    const callback = () => {
      onClose();
      refetch();
    };
    dispatch(createOrganization(payload, callback));
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <div style={{float: "right"}}>
        <ModalHeader>
          <FaTimes style={{cursor: "pointer"}} onClick={() => onClose()} size={32} />
        </ModalHeader>
      </div>
      <ModalBody>
        {/*<div className="pl-lg-4">*/}
        <OrgForm onFormSubmit={onSubmit} />
        {/*</div>*/}
      </ModalBody>
    </Modal>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

AddAlert.propTypes = {
  open: PropTypes.bool,
};

export default memo(AddAlert, areEqual);
